// import Swiper, { Navigation } from "swiper";

document.addEventListener("DOMContentLoaded", () => {
  const productRowSliderEls = document.querySelectorAll(".product-row__slider");
  if (productRowSliderEls.length !== 0) {
    productRowSliderEls.forEach((sliderEl) => {
      new Swiper(sliderEl, {
        loop: true,
        spaceBetween: 15,
        slidesPerView: 1.1,

        // modules: [Navigation],

        navigation: {
          nextEl: ".product-row__nav--next",
          prevEl: ".product-row__nav--prev",
        },

        breakpoints: {
          // when window width is >= 480px
          480: {
            spaceBetween: 25,
            slidesPerView: 2.1,
          },

          // when window width is >= 768px
          768: {
            spaceBetween: 25,
            slidesPerView: 3.1,
          },

          // when window width is >= 1200px
          1200: {
            slidesPerView: 4,
            spaceBetween: 45,
          },
        },
      });
    });
  }
});
